export * from './muvicard-register.page'
